webpackJsonp([114276838955818,60335399758886],{

/***/ 128:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(221);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(128);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return Glamor.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(239), __esModule: true };

/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(241), __esModule: true };

/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(230);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ }),

/***/ 237:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ }),

/***/ 14:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(264);
	module.exports = __webpack_require__(18).Object.assign;


/***/ }),

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(266);
	module.exports = __webpack_require__(18).Object.keys;


/***/ }),

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(53);
	var gOPS = __webpack_require__(112);
	var pIE = __webpack_require__(87);
	var toObject = __webpack_require__(117);
	var IObject = __webpack_require__(156);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(30)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ }),

/***/ 258:
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(29);
	var core = __webpack_require__(18);
	var fails = __webpack_require__(30);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),

/***/ 264:
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(29);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(254) });


/***/ }),

/***/ 266:
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(117);
	var $keys = __webpack_require__(53);
	
	__webpack_require__(258)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),

/***/ 298:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(300);
	var isArguments = __webpack_require__(299);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 299:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 300:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 307:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 318:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.navigateTo = undefined;
	
	var _extends2 = __webpack_require__(236);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(232);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _objectWithoutProperties2 = __webpack_require__(237);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(86);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(106);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(105);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.withPrefix = withPrefix;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(103);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pathPrefix = "/"; /*global __PREFIX_PATHS__, __PATH_PREFIX__ */
	
	if (false) {
	  pathPrefix = __PATH_PREFIX__;
	}
	
	function withPrefix(path) {
	  return normalizePath(pathPrefix + path);
	}
	
	function normalizePath(path) {
	  return path.replace(/^\/\//g, "/");
	}
	
	var NavLinkPropTypes = {
	  activeClassName: _propTypes2.default.string,
	  activeStyle: _propTypes2.default.object,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  isActive: _propTypes2.default.func,
	  location: _propTypes2.default.object
	
	  // Set up IntersectionObserver
	};var handleIntersection = function handleIntersection(el, cb) {
	  var io = new window.IntersectionObserver(function (entries) {
	    entries.forEach(function (entry) {
	      if (el === entry.target) {
	        // Check if element is within viewport, remove listener, destroy observer, and run link callback.
	        // MSEdge doesn't currently support isIntersecting, so also test for  an intersectionRatio > 0
	        if (entry.isIntersecting || entry.intersectionRatio > 0) {
	          io.unobserve(el);
	          io.disconnect();
	          cb();
	        }
	      }
	    });
	  });
	  // Add element to the observer
	  io.observe(el);
	};
	
	var GatsbyLink = function (_React$Component) {
	  (0, _inherits3.default)(GatsbyLink, _React$Component);
	
	  function GatsbyLink(props) {
	    (0, _classCallCheck3.default)(this, GatsbyLink);
	
	    // Default to no support for IntersectionObserver
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this));
	
	    var IOSupported = false;
	    if (typeof window !== "undefined" && window.IntersectionObserver) {
	      IOSupported = true;
	    }
	
	    _this.state = {
	      to: withPrefix(props.to),
	      IOSupported: IOSupported
	    };
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  GatsbyLink.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.to !== nextProps.to) {
	      this.setState({
	        to: withPrefix(nextProps.to)
	      });
	      // Preserve non IO functionality if no support
	      if (!this.state.IOSupported) {
	        ___loader.enqueue(this.state.to);
	      }
	    }
	  };
	
	  GatsbyLink.prototype.componentDidMount = function componentDidMount() {
	    // Preserve non IO functionality if no support
	    if (!this.state.IOSupported) {
	      ___loader.enqueue(this.state.to);
	    }
	  };
	
	  GatsbyLink.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    this.props.innerRef && this.props.innerRef(ref);
	
	    if (this.state.IOSupported && ref) {
	      // If IO supported and element reference found, setup Observer functionality
	      handleIntersection(ref, function () {
	        ___loader.enqueue(_this2.state.to);
	      });
	    }
	  };
	
	  GatsbyLink.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        _onClick = _props.onClick,
	        rest = (0, _objectWithoutProperties3.default)(_props, ["onClick"]);
	
	    var El = void 0;
	    if ((0, _keys2.default)(NavLinkPropTypes).some(function (propName) {
	      return _this3.props[propName];
	    })) {
	      El = _reactRouterDom.NavLink;
	    } else {
	      El = _reactRouterDom.Link;
	    }
	
	    return _react2.default.createElement(El, (0, _extends3.default)({
	      onClick: function onClick(e) {
	        // eslint-disable-line
	        _onClick && _onClick(e);
	
	        if (e.button === 0 && // ignore right clicks
	        !_this3.props.target && // let browser handle "target=_blank"
	        !e.defaultPrevented && // onClick prevented default
	        !e.metaKey && // ignore clicks with modifier keys...
	        !e.altKey && !e.ctrlKey && !e.shiftKey) {
	          // Is this link pointing to a hash on the same page? If so,
	          // just scroll there.
	          var pathname = _this3.state.to;
	          if (pathname.split("#").length > 1) {
	            pathname = pathname.split("#").slice(0, -1).join("");
	          }
	          if (pathname === window.location.pathname) {
	            var hashFragment = _this3.state.to.split("#").slice(1).join("#");
	            var element = document.getElementById(hashFragment);
	            if (element !== null) {
	              element.scrollIntoView();
	              return true;
	            }
	          }
	
	          // In production, make sure the necessary scripts are
	          // loaded before continuing.
	          if (true) {
	            e.preventDefault();
	            window.___navigateTo(_this3.state.to);
	          }
	        }
	
	        return true;
	      }
	    }, rest, {
	      to: this.state.to,
	      innerRef: this.handleRef
	    }));
	  };
	
	  return GatsbyLink;
	}(_react2.default.Component);
	
	GatsbyLink.propTypes = (0, _extends3.default)({}, NavLinkPropTypes, {
	  innerRef: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  to: _propTypes2.default.string.isRequired
	});
	
	GatsbyLink.contextTypes = {
	  router: _propTypes2.default.object
	};
	
	exports.default = GatsbyLink;
	var navigateTo = exports.navigateTo = function navigateTo(pathname) {
	  window.___navigateTo(withPrefix(pathname));
	};

/***/ }),

/***/ 403:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(422);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(298);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(404);
	
	var _HelmetConstants = __webpack_require__(204);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 204:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 404:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(3);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(204);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 422:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(307);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	var _shallowequal = __webpack_require__(437);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !(0, _shallowequal2.default)(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(_react.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = _exenv2.default.canUseDOM;
	
	
	    return SideEffect;
	  };
	};

/***/ }),

/***/ 437:
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),

/***/ 308:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Button = function Button(_ref) {
	  var className = _ref.className,
	      secondary = _ref.secondary,
	      rest = _objectWithoutProperties(_ref, ['className', 'secondary']);
	
	  return Glamor.createElement('button', _extends({}, rest, {
	    css: [styles.button, secondary && styles.secondary],
	    className: className
	  }));
	};
	
	exports.default = Button;
	
	
	var bg = '#222';
	var bgHover = '#111';
	var bgActive = '#000';
	
	var styles = {
	  button: {
	    backgroundColor: bg,
	    borderColor: bg,
	    borderRadius: '1.5rem',
	    borderStyle: 'solid',
	    borderWidth: '3px',
	    color: '#fff',
	    cursor: 'pointer',
	    fontSize: '1em',
	    fontWeight: '600',
	    outline: 0,
	    padding: '.875rem 2.625rem',
	    ':hover': {
	      borderColor: bgHover,
	      backgroundColor: bgHover,
	      color: '#fff'
	    },
	    ':active': {
	      backgroundColor: bgActive
	    }
	  },
	  secondary: {
	    backgroundColor: 'transparent',
	    color: bg
	  }
	};
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Centered = function Centered(props) {
	  return Glamor.createElement(
	    'div',
	    { css: props.bg && _extends({}, styles.bg, { backgroundImage: 'url(' + props.bg + ')' }) },
	    Glamor.createElement(
	      'div',
	      {
	        css: [styles.wrapper, props.bg && styles.bgOverlay],
	        className: props.className
	      },
	      Glamor.createElement(
	        'div',
	        { css: styles.content, className: props.contentClassName },
	        props.children
	      )
	    )
	  );
	};
	
	exports.default = Centered;
	
	
	var styles = {
	  wrapper: {
	    '::before': {
	      content: '""',
	      display: 'inline-block',
	      height: '100vh',
	      verticalAlign: 'middle'
	    }
	  },
	  bg: {
	    backgroundPosition: 'center',
	    backgroundRepeat: 'no-repeat',
	    backgroundSize: 'cover'
	  },
	  bgOverlay: {
	    backgroundColor: 'rgba(255, 255, 255, 0.66)'
	  },
	  content: {
	    display: 'inline-block',
	    verticalAlign: 'middle'
	  }
	};
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Container = function Container(props) {
	  return Glamor.createElement(
	    'div',
	    { css: styles.container, className: (0, _classnames2.default)('ph3', 'ph0-l', props.className) },
	    props.children
	  );
	};
	
	exports.default = Container;
	
	
	var styles = {
	  container: {
	    width: '100%',
	    maxWidth: '960px',
	    margin: '0 auto'
	  }
	};
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 57:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	exports.default = EmailButton;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(57);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function onClick() {
	  var addr = 'info';
	  var domain = 'westpoint.se';
	  var url = 'mailto:' + addr + '@' + domain;
	
	  window.location = url;
	}
	
	function EmailButton() {
	  return Glamor.createElement(
	    'button',
	    { className: 'email-button', onClick: onClick },
	    Glamor.createElement(
	      'svg',
	      {
	        className: 'email-button-svg',
	        width: '17px',
	        height: '17px',
	        viewBox: '0 0 17 17',
	        version: '1.1',
	        xmlns: 'http://www.w3.org/2000/svg'
	      },
	      Glamor.createElement('path', {
	        d: 'M0,0 L3.066,16.351 L8.175,12.263 L12.262,15.328 L12.262,10.22 L16.349,7.154 L0,0 Z M0.218,0.198 L10.955,9.483 L9.531,10.45 L0.218,0.198 Z',
	        id: 'Shape'
	      })
	    )
	  );
	}
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Link = function Link(props) {
	  return Glamor.createElement('a', _extends({}, props, {
	    css: {
	      color: '#2879fc',
	      textDecoration: 'none',
	      ':hover': {
	        textDecoration: 'underline'
	      }
	    }
	  }));
	};
	
	exports.default = Link;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	exports.default = Logo;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Logo(props) {
	  return Glamor.createElement(
	    "div",
	    { className: props.className },
	    Glamor.createElement(
	      "svg",
	      {
	        width: "83px",
	        height: "102px",
	        viewBox: "0 0 83 102",
	        version: "1.1",
	        xmlns: "http://www.w3.org/2000/svg"
	      },
	      Glamor.createElement("path", {
	        d: "M41.088,0 C41.088,0 11.096,0.078 0,11.174 L0,74.203 C0,74.203 26.145,86.853 41.088,101.797 C56.031,86.854 82.175,74.203 82.175,74.203 L82.175,11.173 C71.081,0.078 41.088,0 41.088,0 Z M76.308,69.056 C76.308,69.056 53.898,79.9 41.088,92.708 C28.281,79.9 5.873,69.056 5.873,69.056 L5.873,15.032 C15.38,5.521 41.088,5.454 41.088,5.454 C41.088,5.454 66.796,5.521 76.308,15.032 L76.308,69.056 Z",
	        id: "Shape",
	        fill: "#000000",
	        fillRule: "nonzero"
	      }),
	      Glamor.createElement("path", {
	        d: "M39.82425,32.7170101 L39.78725,32.6810101 L39.71725,32.6440101 L39.64325,32.6090101 C39.59625,32.6090101 39.56525,32.6010101 39.55525,32.5880101 C39.53925,32.5770101 39.51225,32.5710101 39.46325,32.5710101 C39.34225,32.5220101 39.22125,32.4870101 39.10025,32.4630101 C38.97725,32.4380101 38.85625,32.4140101 38.73525,32.3890101 C38.61425,32.3420101 38.48725,32.3170101 38.35425,32.3170101 L37.97125,32.3170101 C37.85025,32.3420101 37.72125,32.3600101 37.59225,32.3720101 C37.45525,32.3860101 37.32825,32.4150101 37.20725,32.4640101 C36.96725,32.5110101 36.73425,32.5970101 36.51925,32.7180101 C36.29825,32.8400101 36.09325,32.9600101 35.90025,33.0800101 C35.70525,33.2260101 35.52925,33.3720101 35.37125,33.5180101 C35.21525,33.6640101 35.07225,33.8220101 34.95325,33.9910101 C34.66225,34.3540101 34.43225,34.7060101 34.26425,35.0450101 C34.06925,35.4090101 33.91225,35.7790101 33.79125,36.1530101 C33.66625,36.5290101 33.56125,36.9110101 33.46325,37.2990101 C33.39125,37.6610101 33.35625,38.0510101 33.35625,38.4620101 C33.30525,38.8260101 33.30525,39.2140101 33.35625,39.6260101 C33.40125,40.0140101 33.46325,40.3960101 33.53825,40.7710101 C33.60825,41.1470101 33.71825,41.5160101 33.86225,41.8800101 C34.13025,42.6300101 34.49525,43.3110101 34.95425,43.9150101 C35.46425,44.5710101 36.04625,45.0910101 36.70225,45.4790101 C36.70225,45.5020101 36.70425,45.5150101 36.71825,45.5150101 C36.73025,45.5150101 36.73625,45.5270101 36.73625,45.5520101 C36.71125,45.5990101 36.68725,45.6560101 36.66625,45.7150101 C36.64125,45.7760101 36.60325,45.8410101 36.55525,45.9140101 C36.28925,46.4230101 35.96325,46.9450101 35.57325,47.4770101 C35.40525,47.7210101 35.22925,47.9440101 35.04825,48.1500101 C34.86725,48.3560101 34.67925,48.5570101 34.48425,48.7500101 C34.36325,48.8490101 34.26125,48.9380101 34.17525,49.0210101 C34.08925,49.1070101 34.00125,49.1870101 33.90225,49.2600101 C33.78125,49.3070101 33.67725,49.3620101 33.59325,49.4220101 C33.50725,49.4830101 33.41925,49.5380101 33.32325,49.5850101 C33.22325,49.6340101 33.13525,49.6640101 33.04825,49.6760101 C32.96225,49.6890101 32.88625,49.7060101 32.81225,49.7320101 L32.63025,49.7320101 L32.52125,49.7320101 L32.48425,49.7320101 L32.44925,49.7320101 L32.37525,49.7320101 C32.16025,49.7320101 31.97925,49.6940101 31.83225,49.6220101 C31.68725,49.5740101 31.56225,49.5260101 31.46725,49.4760101 L31.21525,49.2230101 C31.11525,49.0770101 31.04525,48.9440101 30.99425,48.8230101 C30.84925,48.5080101 30.73825,48.0720101 30.66825,47.5130101 C30.61725,47.2460101 30.59825,46.9750101 30.59825,46.6960101 C30.59825,46.4170101 30.60825,46.1310101 30.63325,45.8410101 C30.63325,45.5520101 30.64325,45.2560101 30.66825,44.9520101 C30.69125,44.6480101 30.72925,44.3390101 30.77925,44.0220101 L31.10325,42.1690101 C31.22425,41.5390101 31.37125,40.9140101 31.54125,40.2960101 C31.70725,39.6790101 31.89325,39.0560101 32.08425,38.4230101 C32.20525,38.1090101 32.31425,37.8000101 32.41425,37.4960101 C32.51025,37.1950101 32.60525,36.8860101 32.70125,36.5690101 C32.75225,36.4010101 32.81225,36.2430101 32.88725,36.0980101 C32.95725,35.9520101 33.01825,35.8060101 33.06925,35.6600101 C33.09225,35.5390101 33.15325,35.3820101 33.25125,35.1870101 L33.32525,34.9690101 L33.36025,34.8590101 L33.39525,34.8240101 L33.39525,34.7870101 C33.44625,34.6900101 33.46725,34.6170101 33.46725,34.5700101 C33.71125,33.8680101 33.66225,33.1810101 33.32425,32.5130101 C32.98225,31.8480101 32.47025,31.3940101 31.79325,31.1510101 C31.09025,30.9090101 30.40825,30.9580101 29.74025,31.2970101 C29.07425,31.6370101 28.61925,32.1580101 28.37925,32.8610101 L28.37925,32.8980101 L28.30525,33.0410101 L28.26825,33.1520101 L28.19825,33.4430101 C28.14725,33.5150101 28.11625,33.5930101 28.10625,33.6780101 C28.09425,33.7640101 28.06325,33.8550101 28.01225,33.9500101 C27.94025,34.2410101 27.84625,34.5820101 27.72325,34.9690101 C27.62525,35.3070101 27.53525,35.6540101 27.45225,36.0050101 C27.36625,36.3580101 27.27425,36.7130101 27.17925,37.0770101 C27.00925,37.7810101 26.85525,38.4830101 26.72625,39.1860101 C26.58925,39.8890101 26.46425,40.5920101 26.34125,41.2930101 C26.29425,41.6560101 26.24525,42.0210101 26.19525,42.3840101 C26.14825,42.7480101 26.09925,43.1230101 26.05425,43.5110101 C26.02925,43.7050101 26.01525,43.9070101 26.01525,44.1130101 C26.01525,44.3180101 26.00325,44.5170101 25.97825,44.7130101 C25.83325,45.0510101 25.67725,45.3790101 25.50725,45.6920101 C25.33725,46.0080101 25.15525,46.3240101 24.96025,46.6390101 C24.74325,46.9770101 24.51325,47.3170101 24.27225,47.6570101 C24.02625,47.9980101 23.77425,48.3110101 23.50625,48.6020101 C23.38325,48.7730101 23.25225,48.9230101 23.10625,49.0560101 C22.96025,49.1900101 22.81525,49.3180101 22.67025,49.4380101 C22.52425,49.5590101 22.37925,49.6690101 22.23225,49.7660101 C22.08725,49.8630101 21.92925,49.9490101 21.75925,50.0210101 C21.46825,50.1900101 21.16725,50.2990101 20.85125,50.3480101 C20.58525,50.4200101 20.29425,50.4320101 19.97825,50.3820101 L19.90625,50.3820101 L19.87125,50.3820101 L19.87125,50.3480101 L19.83225,50.3480101 L19.79725,50.3480101 C19.74625,50.3230101 19.71125,50.3100101 19.69025,50.3100101 C19.66525,50.3100101 19.62625,50.2990101 19.58125,50.2740101 C19.53225,50.2530101 19.48925,50.2270101 19.45225,50.2020101 C19.41725,50.1800101 19.37425,50.1540101 19.32525,50.1290101 C19.25325,50.0580101 19.21625,49.9960101 19.21625,49.9490101 C19.19525,49.9240101 19.18125,49.8760101 19.18125,49.8030101 C19.15625,49.7780101 19.14425,49.7170101 19.14425,49.6190101 C19.12125,49.5460101 19.10925,49.4370101 19.10925,49.2930101 L19.10925,48.4560101 C19.13025,48.2880101 19.15625,48.1180101 19.18125,47.9470101 C19.20625,47.7780101 19.24225,47.5950101 19.29025,47.4020101 C19.33725,47.2330101 19.38625,47.0550101 19.43625,46.8750101 C19.48125,46.6930101 19.53225,46.5060101 19.58125,46.3120101 C19.60625,46.2140101 19.62625,46.1240101 19.65325,46.0400101 C19.67625,45.9540101 19.70225,45.8630101 19.72725,45.7670101 C19.82125,45.5250101 19.88125,45.3440101 19.90725,45.2220101 C19.97925,45.0280101 20.05325,44.8390101 20.12425,44.6590101 C20.19825,44.4760101 20.27025,44.2890101 20.34525,44.0940101 C20.94925,42.5190101 21.60525,41.0050101 22.30825,39.5500101 C22.67125,38.7980101 23.04625,38.0480101 23.43325,37.2960101 L23.68925,36.7500101 L23.98025,36.2050101 L24.27325,35.6240101 L24.56425,35.1150101 L24.56425,35.0780101 C24.90025,34.4250101 24.96025,33.7470101 24.74425,33.0410101 C24.52325,32.3410101 24.10125,31.8180101 23.47125,31.4780101 C22.81725,31.1150101 22.13125,31.0370101 21.41825,31.2440101 C20.69925,31.4480101 20.17425,31.8800101 19.83425,32.5340101 L19.72925,32.7160101 L19.65525,32.8620101 L19.50925,33.1530101 C19.46225,33.2730101 19.40525,33.3760101 19.34525,33.4620101 C19.28425,33.5470101 19.23225,33.6500101 19.18325,33.7700101 C19.13225,33.8700101 19.08525,33.9640101 19.03725,34.0620101 C18.98625,34.1600101 18.94125,34.2680101 18.89225,34.3890101 C18.84125,34.4860101 18.79425,34.5840101 18.74625,34.6800101 C18.69925,34.7770101 18.64825,34.8720101 18.60125,34.9710101 C18.40825,35.3830101 18.22425,35.7950101 18.05825,36.2060101 C17.88625,36.6190101 17.71625,37.0310101 17.54625,37.4430101 C17.45025,37.6590101 17.35725,37.8730101 17.27525,38.0790101 C17.19125,38.2850101 17.10925,38.4950101 17.03925,38.7140101 C16.96725,38.9330101 16.89325,39.1520101 16.82225,39.3700101 C16.74625,39.5880101 16.67725,39.7940101 16.60125,39.9870101 L16.16525,41.2960101 C16.09325,41.5140101 16.02425,41.7380101 15.96425,41.9680101 C15.90525,42.1990101 15.84925,42.4230101 15.80225,42.6410101 C15.65725,43.0530101 15.54625,43.5020101 15.47425,43.9870101 C15.42525,44.1800101 15.37625,44.4250101 15.32925,44.7160101 C15.30425,44.8360101 15.28825,44.9520101 15.27225,45.0610101 C15.26225,45.1700101 15.24525,45.2840101 15.21925,45.4070101 C15.16825,45.6480101 15.13325,45.8910101 15.10825,46.1320101 C15.08825,46.3760101 15.06325,46.6190101 15.03825,46.8610101 C14.98725,47.3710101 14.98725,47.9030101 15.03825,48.4610101 C15.06325,48.7280101 15.09125,49.0010101 15.12625,49.2800101 C15.16725,49.5580101 15.22025,49.8540101 15.29025,50.1700101 C15.34125,50.3150101 15.39725,50.4670101 15.45825,50.6250101 C15.51725,50.7810101 15.58125,50.9350101 15.65725,51.0800101 C15.75325,51.2480101 15.84825,51.4120101 15.94825,51.5700101 C16.04425,51.7280101 16.15325,51.8790101 16.27425,52.0240101 C16.51425,52.3150101 16.80525,52.5690101 17.14725,52.7870101 C17.50825,53.0050101 17.86025,53.1510101 18.20225,53.2240101 C18.49325,53.3200101 18.81925,53.3690101 19.18225,53.3690101 L19.61825,53.3690101 L19.76425,53.3690101 L19.79925,53.3690101 L19.83425,53.3690101 L19.87325,53.3690101 C19.91825,53.3440101 19.99425,53.3320101 20.09025,53.3320101 C20.38125,53.2850101 20.66425,53.2250101 20.94525,53.1520101 C21.22225,53.0780101 21.49625,52.9820101 21.76125,52.8610101 C22.29425,52.6420101 22.75525,52.3500101 23.14225,51.9890101 C23.55425,51.6480101 23.90625,51.2980101 24.19725,50.9350101 C24.36925,50.7400101 24.52125,50.5400101 24.65225,50.3330101 C24.78725,50.1290101 24.91425,49.9280101 25.03525,49.7340101 C25.22625,49.3950101 25.41625,49.0600101 25.59925,48.7340101 C25.78125,48.4060101 25.94525,48.0740101 26.08925,47.7330101 C26.11025,47.8060101 26.13225,47.8850101 26.14225,47.9690101 C26.15425,48.0540101 26.17325,48.1340101 26.19525,48.2060101 C26.24625,48.4230101 26.28925,48.6420101 26.32425,48.8590101 C26.36325,49.0780101 26.41625,49.2970101 26.48625,49.5140101 C26.56025,49.7330101 26.64025,49.9520101 26.72625,50.1680101 C26.81025,50.3850101 26.91425,50.6050101 27.03525,50.8210101 C27.15425,51.0410101 27.28325,51.2640101 27.41825,51.4950101 C27.54925,51.7260101 27.71125,51.9360101 27.90625,52.1310101 C28.09925,52.3260101 28.30625,52.5190101 28.52525,52.7130101 C28.74225,52.9050101 28.98225,53.0750101 29.25425,53.2220101 C29.49425,53.3410101 29.74225,53.4580101 30.00025,53.5660101 C30.25225,53.6770101 30.51425,53.7540101 30.78125,53.8040101 C31.04725,53.8740101 31.29725,53.9250101 31.54325,53.9490101 C31.78525,53.9720101 32.02525,53.9860101 32.27225,53.9860101 L32.37725,53.9860101 L32.45125,53.9860101 L32.48625,53.9860101 L32.52325,53.9860101 L32.55825,53.9860101 L32.63225,53.9860101 C32.70225,53.9860101 32.77725,53.9780101 32.84925,53.9680101 C32.92325,53.9560101 32.99425,53.9480101 33.07025,53.9480101 C33.28725,53.9250101 33.55025,53.8620101 33.86725,53.7660101 C34.13525,53.6940101 34.38325,53.6080101 34.61325,53.5120101 C34.84325,53.4140101 35.05825,53.3070101 35.25025,53.1840101 C35.46925,53.0630101 35.66825,52.9300101 35.85025,52.7850101 C36.03025,52.6390101 36.22125,52.4940101 36.41625,52.3470101 C36.73025,52.0570101 37.03125,51.7560101 37.32225,51.4400101 C37.85525,50.8590101 38.32825,50.2160101 38.74025,49.5130101 C38.93525,49.1740101 39.11525,48.8400101 39.28725,48.5140101 C39.45725,48.1850101 39.62325,47.8540101 39.79325,47.5130101 C39.88925,47.2720101 39.98225,47.0400101 40.06825,46.8230101 C40.15225,46.6040101 40.24225,46.3870101 40.34125,46.1690101 C40.51125,46.1220101 40.67525,46.0720101 40.82925,46.0230101 C40.98525,45.9750101 41.14025,45.9260101 41.28425,45.8770101 C41.64525,45.7310101 41.98725,45.5560101 42.30325,45.3510101 C42.60225,45.1560101 42.88525,44.9420101 43.16025,44.7120101 C43.06825,45.1370101 42.98025,45.5650101 42.88525,45.9850101 L42.81125,46.1680101 C42.81125,46.1910101 42.78625,46.2760101 42.74125,46.4220101 L42.63025,46.6410101 L42.55625,46.8590101 C42.48425,47.0300101 42.41725,47.1860101 42.35725,47.3320101 C42.29725,47.4780101 42.23025,47.6360101 42.15825,47.8050101 C41.86725,48.4120101 41.56725,49.0170101 41.25025,49.6220101 C41.10425,49.9380101 40.95125,50.2390101 40.79525,50.5310101 C40.63525,50.8210101 40.47325,51.1250101 40.30525,51.4400101 C40.13525,51.7310101 39.96525,52.0270101 39.79325,52.3310101 C39.62325,52.6350101 39.45725,52.9420101 39.28725,53.2570101 C39.21125,53.4030101 39.13525,53.5480101 39.04925,53.6950101 C38.96325,53.8400101 38.87525,53.9980101 38.77625,54.1660101 C38.70425,54.3120101 38.62625,54.4650101 38.54225,54.6210101 C38.45625,54.7790101 38.38025,54.9430101 38.30425,55.1130101 C38.20825,55.2340101 38.12425,55.3920101 38.05225,55.5860101 C38.00325,55.6820101 37.96825,55.7660101 37.94325,55.8400101 L37.86925,55.9490101 L37.79725,56.0580101 C37.72325,56.2280101 37.65825,56.3900101 37.60025,56.5480101 C37.53925,56.7040101 37.47125,56.8700101 37.39725,57.0380101 C37.10625,57.6670101 36.83825,58.3110101 36.59825,58.9660101 C36.35625,59.6200101 36.11625,60.2770101 35.86925,60.9290101 C35.41025,62.2140101 35.01225,63.5460101 34.67025,64.9270101 L34.59825,65.1830101 L34.59825,65.2920101 L34.56325,65.4370101 L34.45425,65.9820101 C34.40525,66.1770101 34.37625,66.3510101 34.36025,66.5090101 C34.35225,66.6670101 34.31925,66.8430101 34.27225,67.0340101 C34.24725,67.2290101 34.23125,67.4190101 34.21525,67.5980101 C34.20525,67.7820101 34.19725,67.9690101 34.19725,68.1640101 L34.19725,68.7460101 C34.22225,68.8420101 34.23225,68.9370101 34.23225,69.0370101 C34.23225,69.1330101 34.25725,69.2400101 34.30625,69.3630101 C34.35525,69.6290101 34.44125,69.8710101 34.56225,70.0900101 C34.60925,70.1390101 34.65025,70.1970101 34.68725,70.2740101 C34.72425,70.3420101 34.77925,70.4050101 34.85325,70.4540101 C34.95125,70.5990101 35.08025,70.7100101 35.25125,70.7800101 C35.35125,70.8540101 35.51725,70.9150101 35.76125,70.9620101 C35.81025,70.9870101 35.85125,71.0010101 35.88625,71.0010101 C35.92725,71.0010101 35.96825,71.0130101 36.01525,71.0360101 L36.05025,71.0360101 L36.08925,71.0360101 L36.12425,71.0360101 L36.23325,71.0360101 L36.63125,71.0360101 C36.77525,71.0360101 36.91025,71.0130101 37.03125,70.9620101 C37.32225,70.8900101 37.55425,70.8060101 37.72025,70.7100101 C37.84525,70.6590101 37.95025,70.6030101 38.05025,70.5460101 C38.14625,70.4820101 38.24125,70.4290101 38.34125,70.3800101 C38.72825,70.1400101 39.06625,69.8720101 39.35725,69.5810101 L39.79325,69.1430101 C39.86925,69.0710101 39.93625,68.9970101 39.99225,68.9260101 C40.05625,68.8520101 40.12125,68.7800101 40.19525,68.7050101 C40.31625,68.5600101 40.42925,68.4120101 40.54125,68.2520101 C40.65025,68.0960101 40.76425,67.9430101 40.88525,67.7970101 C41.34425,67.1450101 41.73325,66.5020101 42.04925,65.8730101 L42.48525,64.8910101 C42.55725,64.7190101 42.63125,64.5550101 42.70425,64.4010101 C42.77825,64.2410101 42.84725,64.0670101 42.92325,63.8720101 C42.97225,63.7040101 43.03425,63.5400101 43.10525,63.3820101 C43.17525,63.2260101 43.23825,63.0480101 43.28725,62.8570101 C43.36125,62.6870101 43.43025,62.5230101 43.48825,62.3670101 C43.54925,62.2070101 43.60325,62.0450101 43.65225,61.8730101 C43.77125,61.5370101 43.87925,61.2030101 43.97825,60.8770101 C44.07425,60.5510101 44.18525,60.2150101 44.30425,59.8750101 C44.35525,59.7050101 44.40225,59.5430101 44.45025,59.3850101 C44.49525,59.2270101 44.54625,59.0630101 44.59525,58.8950101 L44.88625,57.8750101 C45.27525,56.5430101 45.63625,55.2170101 45.97825,53.8950101 C46.31425,52.5740101 46.65625,51.2480101 46.99625,49.9160101 C47.18925,49.1170101 47.38525,48.3110101 47.58025,47.4970101 C47.76925,46.6850101 47.95125,45.8800101 48.12125,45.0800101 C48.17225,45.0070101 48.21525,44.9340101 48.25025,44.8600101 C48.28525,44.7880101 48.32825,44.7170101 48.37725,44.6440101 C48.49825,44.4490101 48.61125,44.2500101 48.72325,44.0430101 C48.83225,43.8390101 48.94625,43.6370101 49.06525,43.4440101 C49.33325,43.0540101 49.58825,42.6680101 49.83125,42.2790101 C50.07525,41.8920101 50.32725,41.5150101 50.59325,41.1520101 C50.71825,40.9580101 50.84925,40.7700101 50.99525,40.5890101 C51.14025,40.4080101 51.27225,40.2210101 51.39725,40.0260101 L52.26625,38.9340101 C52.41125,38.7410101 52.55725,38.5650101 52.70225,38.4080101 C52.84825,38.2510101 52.99525,38.0860101 53.14025,37.9170101 C53.21425,37.8190101 53.29225,37.7340101 53.37825,37.6610101 C53.46225,37.5900101 53.54025,37.5060101 53.61225,37.4070101 L54.08525,36.9360101 C54.25525,36.7900101 54.41925,36.6440101 54.57725,36.4980101 C54.73325,36.3520101 54.89725,36.2200101 55.06725,36.1000101 L55.61425,35.7710101 C55.78025,35.6500101 55.95225,35.5540101 56.12225,35.4810101 C56.19225,35.4310101 56.27025,35.4010101 56.35625,35.3890101 C56.44225,35.3770101 56.52225,35.3590101 56.59425,35.3350101 C56.69025,35.3100101 56.80925,35.2980101 56.95525,35.2980101 L57.02925,35.2980101 L57.02925,35.3350101 L57.06425,35.3350101 C57.11525,35.3350101 57.15025,35.3420101 57.17325,35.3540101 C57.19825,35.3650101 57.23625,35.3720101 57.28425,35.3720101 C57.38025,35.4220101 57.47525,35.4810101 57.57525,35.5550101 C57.74325,35.6510101 57.88825,35.8090101 58.00925,36.0270101 C58.06025,36.0760101 58.08725,36.1310101 58.10125,36.1920101 C58.11325,36.2510101 58.14425,36.3180101 58.19325,36.3910101 C58.21625,36.4630101 58.25625,36.5970101 58.30025,36.7910101 C58.35125,36.9370101 58.38625,37.0860101 58.40925,37.2440101 C58.43425,37.4020101 58.44425,37.5650101 58.44425,37.7340101 C58.49525,38.0750101 58.49525,38.4240101 58.44425,38.7880101 C58.42125,39.5170101 58.31325,40.2670101 58.11825,41.0440101 C58.06925,41.1660101 58.04025,41.2670101 58.03025,41.3530101 C58.01625,41.4380101 57.99725,41.5280101 57.97325,41.6270101 C57.87525,41.8440101 57.81725,42.0380101 57.79125,42.2060101 C57.76625,42.2560101 57.75025,42.3050101 57.73825,42.3520101 C57.72225,42.4020101 57.70525,42.4500101 57.68125,42.4980101 C57.63225,42.5970101 57.60925,42.6930101 57.60925,42.7890101 C57.58425,42.8390101 57.54825,42.9350101 57.50025,43.0810101 C57.47525,43.1290101 57.43925,43.2260101 57.38925,43.3710101 C57.24425,43.7590101 57.09625,44.1470101 56.93625,44.5350101 C56.78025,44.9230101 56.61625,45.3100101 56.44625,45.6960101 C56.25125,46.0860101 56.06725,46.4620101 55.88325,46.8250101 C55.69925,47.1880101 55.50025,47.5530101 55.27925,47.9160101 C55.06425,48.2560101 54.82625,48.5900101 54.57425,48.9150101 C54.31825,49.2430101 54.04525,49.5410101 53.75425,49.8080101 C53.60925,49.9280101 53.46325,50.0490101 53.31825,50.1700101 C53.17225,50.2910101 53.01525,50.3990101 52.84525,50.4980101 C52.50925,50.7160101 52.19325,50.8370101 51.90225,50.8610101 C51.61125,50.9340101 51.33225,50.9340101 51.06625,50.8610101 C50.89625,50.8110101 50.76125,50.7390101 50.66625,50.6430101 C50.59025,50.5940101 50.52725,50.5390101 50.46725,50.4790101 C50.40325,50.4180101 50.34025,50.3640101 50.26625,50.3140101 C50.24125,50.2660101 50.21925,50.2230101 50.19425,50.1870101 C50.16925,50.1500101 50.14525,50.1110101 50.12025,50.0610101 C50.07325,50.0120101 50.04025,49.9750101 50.03225,49.9530101 C50.01625,49.9280101 49.98725,49.8910101 49.93825,49.8430101 C49.88925,49.7460101 49.85025,49.6550101 49.81125,49.5710101 C49.77625,49.4860101 49.73325,49.3830101 49.68225,49.2630101 C49.63725,49.1640101 49.59825,49.0680101 49.57525,48.9720101 C49.55225,48.8730101 49.51625,48.7650101 49.46625,48.6430101 C49.44325,48.5230101 49.41725,48.4140101 49.39625,48.3160101 C49.37325,48.2200101 49.34525,48.1110101 49.32225,47.9900101 C49.29725,47.8200101 49.17725,47.7120101 48.96125,47.6620101 C48.83625,47.6620101 48.73225,47.6930101 48.65225,47.7550101 C48.56425,47.8140101 48.52325,47.9040101 48.52325,48.0260101 C48.44925,48.5370101 48.44925,49.0450101 48.52325,49.5520101 C48.54425,49.6750101 48.56425,49.8020101 48.57625,49.9350101 C48.58625,50.0690101 48.61925,50.1960101 48.66825,50.3160101 C48.71525,50.4620101 48.76625,50.6010101 48.81425,50.7350101 C48.86125,50.8680101 48.91025,50.9960101 48.96025,51.1170101 C49.03025,51.2370101 49.10525,51.3650101 49.17725,51.4990101 C49.25125,51.6320101 49.34525,51.7610101 49.46625,51.8810101 C49.66125,52.0990101 49.90425,52.3050101 50.19525,52.4980101 C50.31625,52.5960101 50.45325,52.6750101 50.61525,52.7340101 C50.76925,52.7950101 50.92425,52.8490101 51.06825,52.8990101 C51.23425,52.9460101 51.39825,52.9770101 51.55825,52.9890101 C51.71425,53.0010101 51.87825,53.0200101 52.04825,53.0420101 C52.63025,53.0420101 53.21225,52.9460101 53.79625,52.7540101 C53.89225,52.7040101 54.03625,52.6550101 54.22825,52.6080101 C54.32825,52.5580101 54.38825,52.5350101 54.41225,52.5350101 C54.60525,52.4850101 54.78125,52.4310101 54.93925,52.3720101 C55.09325,52.3100101 55.26125,52.2570101 55.42725,52.2070101 C56.08325,51.9650101 56.73825,51.6740101 57.39025,51.3360101 C58.62625,50.7310101 59.81625,49.9780101 60.95625,49.0810101 C61.51325,48.6440101 62.03825,48.1720101 62.53425,47.6630101 C63.03225,47.1540101 63.48725,46.6220101 63.89925,46.0630101 C64.33525,45.5050101 64.73725,44.9240101 65.09825,44.3170101 C65.46125,43.7130101 65.78925,43.0940101 66.07725,42.4640101 C66.24925,42.1490101 66.16325,41.9070101 65.82725,41.7360101 C65.70625,41.6870101 65.57125,41.6870101 65.42725,41.7360101 C65.27925,41.7860101 65.16925,41.8690101 65.09925,41.9910101 C64.54225,43.1300101 63.82825,44.2330101 62.95425,45.2990101 C62.08125,46.3410101 61.13625,47.2390101 60.11625,47.9900101 L59.35425,48.5360101 C59.54925,48.2940101 59.74125,48.0250101 59.93825,47.7340101 C60.25225,47.3220101 60.53625,46.8930101 60.79225,46.4440101 C61.04425,45.9960101 61.28225,45.5430101 61.49725,45.0810101 C61.52225,45.0080101 61.54825,44.9420101 61.57325,44.8820101 C61.59825,44.8220101 61.62425,44.7660101 61.64325,44.7190101 C61.66825,44.6460101 61.69225,44.5780101 61.71725,44.5190101 C61.74225,44.4570101 61.76425,44.4030101 61.78925,44.3550101 C61.83825,44.2340101 61.88725,44.0990101 61.93425,43.9540101 C61.95925,43.9050101 61.98525,43.8470101 62.00825,43.7730101 C62.03325,43.7010101 62.05525,43.6390101 62.08025,43.5920101 L62.29725,42.8270101 C62.34625,42.6810101 62.37925,42.5410101 62.38925,42.4080101 C62.39925,42.2750101 62.43225,42.1480101 62.48325,42.0270101 C62.50425,41.9070101 62.52825,41.7730101 62.55325,41.6290101 C62.57825,41.4830101 62.60225,41.3500101 62.62725,41.2270101 C62.64825,41.0830101 62.66625,40.9430101 62.68025,40.8100101 C62.69025,40.6770101 62.70025,40.5370101 62.70025,40.3910101 C62.74925,39.8330101 62.74925,39.2780101 62.70025,38.7180101 C62.67525,38.4270101 62.63725,38.1380101 62.58925,37.8460101 C62.54225,37.5560101 62.48425,37.2640101 62.40725,36.9730101 C62.26225,36.3930101 62.04625,35.8240101 61.75525,35.2660101 C61.68525,35.1200101 61.60325,34.9800101 61.51925,34.8470101 C61.43525,34.7130101 61.34325,34.5760101 61.24825,34.4300101 C61.12725,34.3090101 61.01025,34.1810101 60.90025,34.0480101 C60.79325,33.9140101 60.66625,33.7870101 60.51925,33.6660101 C60.25325,33.4230101 59.97225,33.2170101 59.68125,33.0460101 C59.34325,32.8540101 59.00325,32.7080101 58.66725,32.6120101 C58.47225,32.5620101 58.29625,32.5260101 58.13625,32.5010101 C57.98025,32.4790101 57.80225,32.4540101 57.61125,32.4290101 L57.37525,32.4290101 C57.28925,32.4290101 57.19925,32.4420101 57.10025,32.4670101 L57.06525,32.4670101 L57.03025,32.4670101 L56.99525,32.4670101 L56.88625,32.4670101 L56.81025,32.4670101 C56.76525,32.4910101 56.72225,32.5010101 56.68725,32.5010101 C56.64825,32.5010101 56.60525,32.5140101 56.56025,32.5390101 C56.19325,32.6120101 55.86725,32.7210101 55.57625,32.8660101 C55.43025,32.9380101 55.30125,33.0160101 55.18025,33.1000101 C55.05525,33.1860101 54.93425,33.2650101 54.81325,33.3370101 C54.57325,33.5320101 54.35625,33.7140101 54.16125,33.8810101 C53.96625,34.0520101 53.77425,34.2350101 53.57925,34.4290101 C53.23725,34.7670101 52.91125,35.1550101 52.59925,35.5910101 C52.52325,35.6900101 52.45325,35.7800101 52.37825,35.8640101 C52.30825,35.9500101 52.23225,36.0520101 52.16125,36.1730101 C52.06125,36.2690101 51.98325,36.3620101 51.92325,36.4450101 C51.86225,36.5300101 51.79625,36.6330101 51.72625,36.7540101 C51.58025,36.9490101 51.44325,37.1490101 51.30625,37.3540101 C51.17525,37.5610101 51.04625,37.7610101 50.92725,37.9540101 C50.63625,38.3690101 50.38025,38.7670101 50.16325,39.1550101 C50.03825,39.3740101 49.91925,39.5870101 49.79625,39.7910101 C49.67525,39.9990101 49.55625,40.1970101 49.43525,40.3910101 C49.33525,40.5370101 49.25525,40.6900101 49.18125,40.8450101 C49.10925,41.0020101 49.02325,41.1550101 48.92325,41.3000101 C48.97425,41.0590101 49.02325,40.8220101 49.06825,40.5910101 C49.11925,40.3610101 49.17025,40.1240101 49.21425,39.8830101 L49.40025,38.8640101 C49.44725,38.6940101 49.48025,38.5240101 49.50525,38.3560101 C49.53025,38.1850101 49.55625,38.0150101 49.57925,37.8450101 L49.76125,36.8260101 L49.94325,35.8090101 C49.96825,35.6400101 49.99225,35.4690101 50.01725,35.2990101 C50.03825,35.1310101 50.06425,34.9600101 50.08725,34.7900101 L50.16325,34.2450101 L50.19825,33.9910101 C50.22325,33.9180101 50.23525,33.8220101 50.23525,33.7000101 C50.28225,33.1420101 50.14925,32.6330101 49.83325,32.1740101 C49.52025,31.7130101 49.08325,31.4220101 48.52625,31.3000101 C47.91925,31.1540101 47.36225,31.2390101 46.85425,31.5550101 C46.34225,31.8700101 46.01425,32.3320101 45.87025,32.9370101 L45.83525,33.0100101 L45.39925,34.9360101 L44.92425,36.8990101 L44.48825,38.8630101 L44.01525,40.8630101 C43.87625,41.4660101 43.74925,42.0730101 43.61725,42.6790101 C43.47225,42.8250101 43.33425,42.9790101 43.18125,43.1160101 C42.93525,43.3590101 42.69525,43.5650101 42.45225,43.7360101 C41.92125,44.1470101 41.38425,44.4380101 40.85325,44.6060101 C40.92725,44.3890101 40.99025,44.1770101 41.05425,43.9720101 C41.11125,43.7650101 41.16925,43.5520101 41.21825,43.3330101 C41.40925,42.5830101 41.55425,41.8670101 41.65025,41.1890101 C41.72625,40.8250101 41.77925,40.4610101 41.81825,40.0990101 C41.85325,39.7350101 41.88225,39.3710101 41.90525,39.0070101 C41.97925,38.2550101 41.97925,37.4920101 41.90525,36.7160101 C41.88225,36.5240101 41.85725,36.3290101 41.83525,36.1340101 C41.81025,35.9420101 41.77425,35.7350101 41.72625,35.5170101 C41.67525,35.3240101 41.62225,35.1180101 41.56225,34.8990101 C41.50125,34.6810101 41.41025,34.4610101 41.28925,34.2450101 C41.24025,34.1240101 41.18525,34.0160101 41.12725,33.9180101 C41.06425,33.8220101 40.98825,33.7130101 40.88925,33.5920101 C40.74325,33.3730101 40.53725,33.1670101 40.27025,32.9720101 C40.16325,32.9000101 40.01925,32.8140101 39.82425,32.7170101 Z M38.95425,38.7140101 C38.90325,39.0300101 38.85025,39.3390101 38.79025,39.6430101 C38.72925,39.9460101 38.66125,40.2560101 38.58725,40.5700101 C38.51725,40.8840101 38.43925,41.1930101 38.35325,41.4970101 C38.26925,41.8010101 38.17725,42.1090101 38.08225,42.4240101 C37.96125,42.6920101 37.85025,42.9630101 37.75425,43.2420101 C37.65425,43.5210101 37.54925,43.7940101 37.42825,44.0590101 C37.01225,43.7210101 36.66425,43.3310101 36.37325,42.8980101 C36.03125,42.3870101 35.77725,41.8420101 35.60925,41.2600101 C35.26925,40.1200101 35.25725,38.9450101 35.57025,37.7330101 C35.71625,37.1520101 35.93525,36.6310101 36.22625,36.1700101 C36.39425,35.8790101 36.55225,35.6610101 36.70125,35.5160101 C36.79725,35.4200101 36.88925,35.3280101 36.97225,35.2430101 C37.05425,35.1600101 37.14625,35.0930101 37.24225,35.0440101 C37.46325,34.9470101 37.64425,34.8730101 37.78925,34.8260101 C37.98425,34.7770101 38.15225,34.7770101 38.29725,34.8260101 C38.37325,34.8500101 38.45725,34.8860101 38.55325,34.9340101 C38.60225,34.9340101 38.62725,34.9470101 38.62725,34.9710101 L38.66225,34.9710101 L38.69725,34.9710101 L38.69725,35.0060101 C38.69725,34.9840101 38.72225,35.0190101 38.77125,35.1160101 L38.87825,35.3340101 C38.92925,35.4300101 38.95625,35.5400101 38.97225,35.6610101 C38.98025,35.7820101 38.99925,35.9040101 39.02525,36.0240101 C39.05025,36.1700101 39.06625,36.3090101 39.08225,36.4420101 C39.09425,36.5770101 39.10025,36.7140101 39.10025,36.8600101 C39.09925,37.5400101 39.05025,38.1580101 38.95425,38.7140101 Z M40.71425,56.0020101 C40.65325,56.2560101 40.60125,56.5160101 40.55225,56.7830101 L40.33525,57.7650101 L40.11425,58.7450101 C40.04225,59.0850101 39.96425,59.4110101 39.88025,59.7270101 C39.79425,60.0410101 39.71625,60.3580101 39.64225,60.6700101 C39.59525,60.8400101 39.55425,61.0040101 39.51525,61.1620101 C39.47825,61.3200101 39.43725,61.4730101 39.39025,61.6170101 C39.34125,61.7850101 39.29625,61.9490101 39.26125,62.1070101 C39.22225,62.2630101 39.18325,62.4160101 39.13425,62.5600101 L39.06025,62.7790101 C39.06025,62.8280101 39.03925,62.9000101 38.98825,62.9980101 L38.84325,63.4710101 L38.51725,64.3810101 L37.86125,66.1250101 C37.74025,66.4160101 37.62525,66.6970101 37.51725,66.9630101 C37.40825,67.2290101 37.28125,67.4960101 37.13425,67.7620101 C37.03625,67.9830101 36.90425,68.1980101 36.73425,68.4140101 C36.66425,68.5140101 36.58925,68.6000101 36.51925,68.6700101 C36.44325,68.7460101 36.37325,68.8070101 36.29825,68.8520101 C36.22625,68.9260101 36.16725,68.9730101 36.11625,68.9970101 L36.08125,68.9970101 L36.04225,69.0380101 C36.06725,69.0380101 36.08125,69.0480101 36.08125,69.0710101 L36.08125,69.1080101 L36.00725,69.1080101 C35.93525,69.0380101 35.88625,68.9620101 35.86125,68.8910101 C35.81425,68.7910101 35.76525,68.6700101 35.71625,68.5260101 C35.66925,68.3310101 35.64425,68.1880101 35.64425,68.0880101 C35.61925,67.9430101 35.60325,67.7930101 35.58725,67.6350101 C35.57725,67.4790101 35.58525,67.3150101 35.60825,67.1450101 C35.60825,66.9750101 35.61225,66.8110101 35.62625,66.6550101 C35.63825,66.4950101 35.65325,66.3460101 35.67925,66.2000101 C35.70425,66.0810101 35.74025,65.9210101 35.79025,65.7270101 L35.82525,65.6180101 L35.86025,65.4730101 L35.89725,65.2560101 C36.09225,64.6000101 36.29725,63.9630101 36.51825,63.3440101 C36.73325,62.7290101 36.97525,62.1020101 37.24125,61.4750101 C37.51125,60.8420101 37.79425,60.2330101 38.09625,59.6370101 C38.39925,59.0430101 38.72125,58.4550101 39.05925,57.8730101 C39.15925,57.7280101 39.24525,57.5820101 39.31525,57.4370101 C39.38925,57.2920101 39.47525,57.1580101 39.57125,57.0370101 L39.64125,56.9300101 L39.71525,56.8210101 C39.76225,56.7230101 39.81125,56.6630101 39.86125,56.6390101 C39.90625,56.5670101 39.95125,56.4930101 39.98425,56.4200101 C40.02525,56.3460101 40.06825,56.2870101 40.11325,56.2380101 C40.23625,56.0930101 40.34225,55.9530101 40.42225,55.8180101 C40.50825,55.6850101 40.61025,55.5580101 40.73125,55.4390101 C40.75625,55.3900101 40.81725,55.3180101 40.91725,55.2180101 C40.84325,55.4870101 40.77525,55.7470101 40.71425,56.0020101 Z",
	        id: "Text",
	        fill: "#000000",
	        fillRule: "nonzero"
	      })
	    ),
	    Glamor.createElement(
	      "div",
	      {
	        css: {
	          fontSize: '2.375rem',
	          lineHeight: 1,
	          marginBottom: '0.25rem'
	        }
	      },
	      "westpoint"
	    ),
	    Glamor.createElement(
	      "div",
	      { css: { fontSize: '0.9375rem', opacity: 0.5 } },
	      "mark & fastighetsteknik"
	    )
	  );
	}
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function noPaddingOverride(props) {
	  return !props.className || props.className.indexOf('pv') === -1;
	}
	
	var Section = function Section(props) {
	  return Glamor.createElement(
	    'section',
	    {
	      className: (0, _classnames2.default)({
	        pv5: noPaddingOverride(props),
	        'pv6-l': noPaddingOverride(props)
	      }, props.className)
	    },
	    props.children
	  );
	};
	
	exports.default = Section;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Button = __webpack_require__(45);
	
	Object.defineProperty(exports, 'Button', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Button).default;
	  }
	});
	
	var _Centered = __webpack_require__(46);
	
	Object.defineProperty(exports, 'Centered', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Centered).default;
	  }
	});
	
	var _Container = __webpack_require__(47);
	
	Object.defineProperty(exports, 'Container', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Container).default;
	  }
	});
	
	var _EmailButton = __webpack_require__(48);
	
	Object.defineProperty(exports, 'EmailButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_EmailButton).default;
	  }
	});
	
	var _Link = __webpack_require__(49);
	
	Object.defineProperty(exports, 'Link', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Link).default;
	  }
	});
	
	var _Logo = __webpack_require__(50);
	
	Object.defineProperty(exports, 'Logo', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Logo).default;
	  }
	});
	
	var _Section = __webpack_require__(51);
	
	Object.defineProperty(exports, 'Section', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Section).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(403);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _navbar = __webpack_require__(228);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _footer = __webpack_require__(224);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	__webpack_require__(308);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import './index.css';
	
	var TemplateWrapper = function TemplateWrapper(_ref) {
	  var children = _ref.children;
	  return Glamor.createElement(
	    'div',
	    { className: 'sans-serif' },
	    Glamor.createElement(_reactHelmet2.default, {
	      title: 'Mark & Fastighetsteknik | Westpoint',
	      meta: [{ name: 'description', content: 'Sample' }, { name: 'keywords', content: 'sample, something' }]
	    }),
	    Glamor.createElement(_navbar2.default, null),
	    children(),
	    Glamor.createElement(_footer2.default, null)
	  );
	};
	
	TemplateWrapper.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = TemplateWrapper;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _components = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer() {
	  return Glamor.createElement(
	    _components.Section,
	    null,
	    Glamor.createElement(
	      _components.Container,
	      { className: 'tc' },
	      Glamor.createElement(
	        'h4',
	        { className: 'mt0 f4' },
	        'Kontakta oss'
	      ),
	      Glamor.createElement(_components.EmailButton, null)
	    )
	  );
	};
	
	exports.default = Footer;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(318);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// const Navbar = () => (
	//   <nav css={styles.navbar}>
	//     <Link to="/">
	//       Bla
	//     </Link>
	//   </nav>
	// );
	
	// export default Navbar;
	exports.default = function () {
	  return null;
	};
	
	var styles = {
	  navbar: {
	    position: 'fixed',
	    top: 0,
	    left: 0,
	    right: 0
	  }
	};
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-e14fa09059462f6b4ce6.js